import sleepImg from "./assets/sleep.png";
import travellerImg from "./assets/traveller.png";

function widgetTimeBlank(rawTime) {
  return (
    <span className="mx-auto text-[24px] text-neutral-400 pl-1">--:--</span>
  );
}

function titleWidget(target) {
  return (
    <span className="text-[12px] font-bold text-neutral-400 mb-1 tracking-widest">
      {target}
    </span>
  );
}

function widgetTime(rawTime) {
  let value = "";
  try {
    const d =
      typeof rawTime === "string" && !rawTime.includes("T")
        ? new Date(`1970-01-01T${rawTime}`)
        : new Date(rawTime);
    value = format(d, "hh:mm A");
  } catch (e) {
    value = rawTime;
  }
  return <span className="text-md font-bold text-neutral-700">{value}</span>;
}

function occupiedWidget() {
  return (
    <div className="text-center items-center justify-center w-full">
      <span className="inline-block items-center text-neutral-500 font-bold text-[13px] tracking-widest">
        OCUPADA
      </span>
      <span className="h-10 flex items-center justify-center italic text-neutral-400 text-[12px]">
        Huesped continua
      </span>
    </div>
  );
}

function CardRoomFooter({ record }) {
  function arrivalWidget() {
    return (
      <div className="grid items-center">
        {titleWidget("CHECK IN")}
        {record.check_in_time ? (
          widgetTime(record.fmt_check_in_time)
        ) : (
          <div className="flex">
            <img
              key="sleep"
              className="w-10 h-10"
              alt="icon-in"
              src={travellerImg}
            />
            {widgetTimeBlank()}
          </div>
        )}
      </div>
    );
  }

  function departureWidget() {
    return (
      <div className="flex flex-col items-center w-full">
        {titleWidget("SALIDA")}
        {record.check_out_time ? (
          widgetTime(record.fmt_check_out_time)
        ) : (
          <div className="flex items-center">
            <img src={sleepImg} className="w-10 h-10" alt="icon-in" />
            {widgetTimeBlank()}
          </div>
        )}
      </div>
    );
  }

  function checkWidget() {
    return (
      <div className="flex p-2 justify-between w-full">
        <div className="flex w-1/2">
          {record.departure_date ? departureWidget() : titleWidget("VACANTE")}
        </div>
        <div className="flex w-1/2 items-center justify-center">
          {record.arrival_date && arrivalWidget()}
        </div>
      </div>
    );
  }

  return (
    <div
      id="card-room-footer"
      className="flex items-center mt-1 border-t border-neutral-200 bg-neutral-50/50"
    >
      {record.occ_state === "occupied" ? occupiedWidget() : checkWidget()}
    </div>
  );
}

export default CardRoomFooter;
